import { useRef, useState } from "react";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { fetchDownloadTemperatureRaport } from "../../../../../redux/api/raports.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { SearchInvoiceDataInterface } from "../../../../../redux/interfaces/raports.interface";

function SearchInvoicesActionButton({
  crudData,
}: {
  itemId: string;
  crudData: SearchInvoiceDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const isDownloading = useRef(false);
  const handleDownloadReport = async () => {
    if (!crudData.doc_trans || isDownloading.current) return;
    isDownloading.current = true;
    setIsLoading(true);
    try {
      await dispatch(
        fetchDownloadTemperatureRaport({
          idRaport: crudData.doc_trans,
        }),
      );
    } finally {
      isDownloading.current = false;
      setIsLoading(false);
    }
  };

  return (
    <ActionMenu
      title={crudData.doc_trans}
      minItemsForMenu={2}
      items={[
        {
          id: "download-temperature-diagram",
          label: "Descarca diagrama temperatura",
          icon: "TEMPERATURE",
          kind: "download",
          tooltip: crudData.doc_trans
            ? "Descarca diagrama de temperatura pentru aceasta expeditie."
            : "Lipseste numarul expeditiei necesar pentru descarcare.",
          disabled: !crudData.doc_trans,
          loading: isLoading,
          onClick: handleDownloadReport,
        },
      ]}
    />
  );
}

export default SearchInvoicesActionButton;
